<template>
  <div
    class="deposit-status"
    :class="{
      'progress-status': deposit.status === 'PENDING',
      'success-status': deposit.status === 'SUCCEEDED',
      'failure-status': deposit.status === 'FAILED',
      'canceled-status': deposit.status === 'CANCELED',
      'na-status': deposit.status === undefined,
    }"
  >
    {{
      deposit.status
        ? $t('deposits.status.' + deposit.status)
        : $t('deposits.status.NOT_AVAILABLE')
    }}
  </div>
</template>

<script>

export default {
  name: "DepositStatusTagNew",
  props: {
    deposit: {
      type: Object,
      required: true
    }
  },
}
</script>

<style lang="scss">
.deposit-status {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  height: fit-content;

  font-style: normal;
  font-weight: 500;
  line-height: 16px;

  &.success-status {
    background-color: $success_100;
    color: $success_800;
  }

  &.failure-status {
    background-color: $danger_50;
    color: $danger_800;
  }

  &.canceled-status {
    background-color: $warn_50;
    color: $warn_800;
  }

  &.progress-status {
    background-color: $primary_100;
    color: $primary_800;
  }

  &.na-status {
    background-color: $neutral_50;
    color: $neutral_600;
  }
}



</style>